import React, { useEffect, useState } from "react";
import styled, { keyframes } from "styled-components";

import PretendardText from "../../atoms/text/pretendardText";
import MainBtn from "../../atoms/button/mainBtn";
import useDisplay from "../../../hooks/useDisplay";
import LSBdDisplay01 from "../../molecules/text/linSeedKr/Bd/lsBdDisplay01";
import LSRgBody02 from "../../molecules/text/linSeedKr/Rg/lsRgBody02";
import { macOSCheck } from "../../../util/macOSCheck";

function ConfirmModal({
  visiable,
  setVisiable,
  title,
  content,
  isScroll,
  isAlert,
  isNegative,
  nText,
  yText,
  onClick,
  onYClick,
}) {
  const { isMobile, isTablet, isDesktop } = useDisplay();

  useEffect(() => {
    if (!isScroll) {
      document.body.style.cssText = `
      position: fixed; 
      top: -${window.scrollY}px;
      overflow-y: hidden;
      width: 99%;`;
      return () => {
        const scrollY = document.body.style.top;
        document.body.style.cssText = "";
        window.scrollTo(0, parseInt(scrollY || "0", 10) * -1);
      };
    }
  }, [isScroll]);

  return (
    <ConfirmModalWrapper $isMobile={isMobile}>
      <ConfirmModalContainer $isMobile={isMobile}>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <LSBdDisplay01
            style={{
              color: "#262C31",
              textAlign: "center",
            }}
          >
            {title ? title : ""}
          </LSBdDisplay01>
          {content ? (
            <PretendardText
              style={{
                color: "#808991",
                fontSize: "16px",
                fontWeight: 400,
                lineHeight: "22.4px",
                letterSpacing: "-0.6px",
                textAlign: "center",
                marginTop: 6,
              }}
            >
              {content ? content : ""}
            </PretendardText>
          ) : null}
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "center",
              alignItems: "center",
              width: "100%",
              marginTop: 25,
            }}
          >
            {!isAlert && (
              <MainBtn
                onClick={onClick}
                style={{
                  background: "#F6F7F8",
                  border: "1px solid #F6F7F8",
                  height: 31,
                  marginRight: 15,
                  width: 77,
                }}
              >
                <LSRgBody02
                  style={{
                    color: "#6F7480",
                    textAlign: "center",
                    marginTop: macOSCheck() ? 0 : 2,
                  }}
                >
                  {nText ? nText : "취소"}
                </LSRgBody02>
              </MainBtn>
            )}
            <MainBtn
              onClick={onYClick}
              isNegative={isNegative}
              style={{
                height: 31,
                minWidth: 77,
                width: "fit-content",
                padding: "0px 25px",
              }}
            >
              <LSRgBody02
                style={{
                  color: "#FFFFFF",
                  textAlign: "center",
                  marginTop: macOSCheck() ? 0 : 2,
                }}
              >
                {yText ? yText : "확인"}
              </LSRgBody02>
            </MainBtn>
          </div>
        </div>
      </ConfirmModalContainer>
    </ConfirmModalWrapper>
  );
}

export default ConfirmModal;

// 페이드인 효과 정의
const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: scale(0.95);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
`;

const ConfirmModalWrapper = styled.div`
  width: 100%;
  height: 100vh;
  background: rgba(0, 0, 0, 0.6);
  backdrop-filter: blur(5px);
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  overflow-y: auto;
  z-index: 1000;
  padding: ${(props) => (props.$isMobile ? "0px 20px" : "70px 0px")};
`;

const ConfirmModalContainer = styled.div`
  width: ${(props) => (props.$isMobile ? "100%" : "394px")};
  padding: ${(props) => (props.$isMobile ? "28px 20px" : "40px")};
  display: flex;
  flex-direction: column;
  position: relative;
  background-color: #fff;
  border-radius: 15px;
  box-shadow: 8px 8px 35px 0px rgba(0, 0, 0, 0.45);

  animation: ${fadeIn} 0.7s ease-out;
`;
